export const mockTestimonials = [
  {
    name: 'Jennifer M.',
    location: 'Texas',
    text: 'No more blood in the sink. No more covering my mouth when I talk. I feel normal again.'
  },
  {
    name: 'Robert T.',
    location: 'Florida',
    text: 'My gums are pink now. Not red and puffy. My breath does not smell anymore. This saved me.'
  },
  {
    name: 'Linda K.',
    location: 'California',
    text: 'I was so embarrassed about my breath. Now I can laugh and smile without worrying. Life changing.'
  }
];